import { helpers } from '@vuelidate/validators'

export default function(length: number) {
	return {
		$validator: function(value: string) {
			return !helpers.req(value) || value.length === length
		},
		$params: { length, type: 'length' } as any
	}
}